import { StrictFilters } from "../hooks/useTasksOverview";
import { isEmptyValue } from "./isEmptyValue";

type CursorParams = {
  lastSeenTaskCreatedAt?: string | null;
  lastSeenTaskId?: string | null;
};

export const getTasksEndpointUrl = (
  filters: StrictFilters & { state: string } & CursorParams
) => {
  let url = `tasks?`;
  for (const key in filters) {
    let value = filters[key as keyof typeof filters];

    if (isEmptyValue(value)) {
      continue;
    }

    if (Array.isArray(value)) {
      value = value.join(",");
    }

    if (key === "quantityType" && typeof value === "string") {
      value = value.toLowerCase().replace(/_/g, "");
    }

    if (typeof value === "boolean") {
      value = value.toString();
    }

    if (value !== undefined) {
      url += `${key}=${encodeURIComponent(String(value))}&`;
    }
  }
  return url;
};
